<template>
  <div
    ref="container"
    :class="codeClassName"></div>
</template>

<script>
import * as monaco from "monaco-editor";

export default {
  name: "codeEditor",
  props: {
    monacoOptions: {
      type: Object,
      default: () => {
        return {
          value: "", // 编辑器的值
          theme: "hc-black", // 主题
          language: "json",
          renderLineHighlight: "gutter",
          folding: true, // 是否折叠
          roundedSelection: false,
          foldingHighlight: true, // 折叠等高线
          foldingStrategy: "indentation", // 折叠方式  auto | indentation
          showFoldingControls: "always", // 是否一直显示折叠 always | mouseover
          disableLayerHinting: true, // 等宽优化
          emptySelectionClipboard: false, // 空选择剪切板
          selectionClipboard: false, // 选择剪切板
          automaticLayout: true, // 自动布局
          codeLens: true, // 代码镜头
          scrollBeyondLastLine: false, // 滚动完最后一行后再滚动一屏幕
          colorDecorators: true, // 颜色装饰器
          accessibilitySupport: "on", // 辅助功能支持  "auto" | "off" | "on"
          lineNumbers: "on", // 行号 取值： "on" | "off" | "relative" | "interval" | function
          lineNumbersMinChars: 5, // 行号最小字符   number
          enableSplitViewResizing: false,
          readOnly: false, //是否只读  取值 true | false
        };
      }
    },
    consoleState: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    codeClassName: function (){
      if(this.consoleState){
        return 'min-box'
      }else{
        return 'max-box'
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 初始化container的内容，销毁之前生成的编辑器
      this.$refs.container.innerHTML = "";

      this.editorOptions = this.monacoOptions;
      // 生成编辑器对象
      this.monacoEditor = monaco.editor.create(
        this.$refs.container,
        this.editorOptions
      );
      // 编辑器内容发生改变时触发
      this.monacoEditor.onDidChangeModelContent(() => {
        this.$emit("change", this.monacoEditor.getValue());
        this.$emit("input", this.monacoEditor.getValue());
      });
    },
    setTabSize(tabSize){
      this.monacoEditor.updateOptions({ tabSize: tabSize })
    },
    setFontSize(fontSize){
      this.monacoEditor.updateOptions({ fontSize: fontSize });
    },
    //设置主题
    setTheme(themeName){
      //'vs' | 'vs-dark' | 'hc-black'
      monaco.editor.setTheme(themeName);
    },
    setLanguage(language){
      monaco.editor.setModelLanguage(this.monacoEditor.getModel(), language) //语言设置
    },

    editorDispose(){
      this.monacoEditor.dispose() //销毁实例
    },
    runFormat(){
      this.monacoEditor.getAction('editor.action.formatDocument').run() //格式化代码
    },
    // 供父组件调用手动获取值
    getVal() {
      return this.monacoEditor.getValue();
    },
    setVal(value){
      this.monacoEditor.setValue(value)
    },

  }
};
</script>

<style scoped>
.min-box{
  height: calc(100vh - 301px);
}
.max-box{
  height: calc(100vh - 100px);
}
</style>
